import API from "../libs/api";

const BASE_PATH = "/api/admin/teacher-attendance";

function buildSchoolAttendanceUrl(schoolId, academicYearId) {
  return `${BASE_PATH}/school/${encodeURIComponent(schoolId)}/academic-year/${encodeURIComponent(academicYearId)}`;
}

const TeacherAttendanceService = {
  createAttendance: (payload) => API.post(BASE_PATH, payload),

  getAttendanceById: (id) => API.get(`${BASE_PATH}/${encodeURIComponent(id)}`),

  getBySchool: (schoolId, academicYearId) =>
    API.get(buildSchoolAttendanceUrl(schoolId, academicYearId)),

  getByTeacher: (teacherId) =>
    API.get(`${BASE_PATH}/teacher/${encodeURIComponent(teacherId)}`),

  getByTeacherAndDate: (teacherId, date) =>
    API.get(
      `${BASE_PATH}/teacher/${encodeURIComponent(teacherId)}/date?date=${encodeURIComponent(date)}`
    ),

  getByTeacherAndMonth: (teacherId, month) =>
    API.get(
      `${BASE_PATH}/teacher/${encodeURIComponent(teacherId)}/month?month=${encodeURIComponent(month)}`
    ),

  getByTeacherAndAcademicYear: (teacherId, academicYearId) =>
    API.get(
      `${BASE_PATH}/teacher/${encodeURIComponent(teacherId)}/academic-year/${encodeURIComponent(academicYearId)}`
    ),

  getBySchoolAndAcademicYear: (schoolId, academicYearId) =>
    API.get(buildSchoolAttendanceUrl(schoolId, academicYearId)),

  getByTeacherAndDateRange: (teacherId, fromDate, toDate) =>
    API.get(
      `${BASE_PATH}/teacher/${encodeURIComponent(teacherId)}/range?fromDate=${encodeURIComponent(fromDate)}&toDate=${encodeURIComponent(toDate)}`
    ),

  updateAttendance: (id, payload) =>
    API.put(`${BASE_PATH}/${encodeURIComponent(id)}`, payload),

  deleteAttendance: (id, deletedBy = "admin") =>
    API.delete(
      `${BASE_PATH}/${encodeURIComponent(id)}?deletedBy=${encodeURIComponent(deletedBy)}`
    ),

  syncDailyAttendance: (schoolId, academicYearId, date) => {
    const dateQuery = date ? `?date=${encodeURIComponent(date)}` : "";
    return API.post(
      `${BASE_PATH}/sync-daily/${encodeURIComponent(schoolId)}/academic-year/${encodeURIComponent(academicYearId)}${dateQuery}`
    );
  },

  exportAndEmailAttendance: (schoolId, academicYearId) =>
    API.post(
      `${BASE_PATH}/export-and-email/${encodeURIComponent(schoolId)}?academicYearId=${encodeURIComponent(academicYearId)}`
    ),
};

export default TeacherAttendanceService;
